
import { Button, TextField } from '@mui/material';
import './App.css';
import { useState } from 'react';
import { executeBatchDelete } from './services/DeleteHelperService';

function App() {
  const [state, setstate] = useState(null)
  const handleChange = (e) => {
    setstate({ ...state, [e.target.name]: e.target.value })
  }
  return (
    <div className="App">
      <TextField
        label="Nom de l'objet"
        variant="outlined"
        name='nomObject'
        onChange={(e) => handleChange(e)}
        sx={{ width: "30%", mb: 2 }}
      />
      <br />
      <TextField
        name='ids'
        label="Identifiants des données à supprimer"
        variant="outlined"
        onChange={(e) => handleChange(e)}
        sx={{ width: "30%", mb: 2 }}
      />
      <br />
      <Button
        onClick={async () => {
          const idsArray = JSON.parse(state.ids).map(item => item.id);
          await executeBatchDelete(state.nomObject, idsArray);
        }}
        variant="contained"
        color="primary"
      >
        Supprimer
      </Button>
    </div>
  );
}

export default App;
